import { render } from "./logoHead.vue?vue&type=template&id=4878c28e&scoped=true"
const script = {}

import "./logoHead.vue?vue&type=style&index=0&id=4878c28e&scoped=true&lang=css"

import exportComponent from "/home/LiuJing/code/MyProjects/YiZhiWang/yizhiwang_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4878c28e"]])

export default __exports__